/** @jsx h */
import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { styled } from 'goober';
import Header from '../../../../components/checkoutWidget/Header';
import UserDetailsHeader from '../../../../components/checkoutWidget/UserDetailsHeader';
import { checkEligibilityRoute } from '../../../../alias/checkoutWidgetRoutes';
import { route } from 'preact-router';
import { orderDetailsResponse } from '../../../../constants/cwData';
import MerchantIcon from '../../../../assets/checkoutWidget/merchant-logo.svg';
import {
  useCheckoutContext,
  useCheckoutDispatchContext,
} from '../../../../storeProviders/checkoutWidgetStore';
import { device } from '../../../../utils/breakPoints';
import CancelModal from '../../../../components/checkoutWidget/CancelModal';

const CheckoutWidgetUIContainer = styled('div')(
  (props) => `
   width: 100%;
   height: 100vh;
   background-color: transparent;
   display: flex;
   justify-content: center;
   align-items: center;
   -webkit-tap-highlight-color: transparent;
   -webkit-touch-callout: none;
   -webkit-user-select: none;
   -khtml-user-select: none;
   -moz-user-select: none;
   -ms-user-select: none;
   user-select: none;
  .checkoutInnerContainer{
    margin: auto;
    background-color: #ffffff;
    width: 100%;
    max-width: 500px;
    height: 100vh;
    padding: 0px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  ${device.desktopMobile`
    .checkoutInnerContainer{
      height: 85vh;
      max-height: 800px;
    }
  `}
  .checkoutInnerWrapper{
    padding: 16px 16px 0;
    flex-grow: 1;
    overflow: hidden;
  }
  .boxShadowWrapperContainer {
    background: #ffffff;
    box-shadow: 1px 1px 14px 1px rgba(0, 14, 40, 0.25);
    border-radius: 15px;
    margin-bottom: 20px;
    overflow: hidden;
  }
  .boxShadowContainer {
    padding: 0 0 10px;
    position: static !important;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
  }
  .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label {
    color: ${props.checkoutTheme.primaryColor} !important;
  }
  
  .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label {
    color: ${props.checkoutTheme.primaryColor} !important;
  }
  
  .mdc-text-field--textarea.mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-text-field__input:focus {
    border-color: ${props.checkoutTheme.primaryColor} !important;
  }
  
   .mdc-text-field--textarea.mdc-text-field--focused:not(.mdc-text-field--disabled) {
    border-color: ${props.checkoutTheme.primaryColor} !important;
  }
  
  .mdc-text-field .mdc-line-ripple {
    background-color: ${props.checkoutTheme.primaryColor} !important;
  }
  
  .mdc-text-field:not(.mdc-text-field--disabled) {
    background-color: #ffffff !important;
  }

  .mdc-button:disabled {
    background-color: rgba(0, 0, 0, 0.12) !important;
    color: rgba(0, 0, 0, 0.37) !important;
  }
  
  .mdc-text-field--outlined:not(.mdc-text-field--disabled).mdc-text-field--focused
    .mdc-notched-outline__path {
    stroke: ${props.checkoutTheme.primaryColor} !important;
  }
  .mdc-checkbox::before,
  .mdc-checkbox::after {
    background-color: #1A73E8 !important;
  }
  .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background,
  .mdc-checkbox__native-control:enabled:indeterminate ~ .mdc-checkbox__background {
    background-color: #1A73E8 !important;
    border-color: #1A73E8 !important;
  }
  .cwChildrenContainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  
  .boxShadowContainer::-webkit-scrollbar,
  .boxShadowContainer::-webkit-scrollbar-thumb,
  .boxShadowContainer::-webkit-scrollbar-track {
    width: 6px;
    border: none;
    background: transparent;
  }
  
  .boxShadowContainer::-webkit-scrollbar-button,
  .boxShadowContainer::-webkit-scrollbar-track-piece,
  .boxShadowContainer::-webkit-scrollbar-corner,
  .boxShadowContainer::-webkit-resizer {
    display: none;
  }
  
  .boxShadowContainer::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background: #B6B7B9;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  }
  
  .boxShadowContainer::-webkit-scrollbar-track {
    background: #E2E2E2;
    border-left: 2px solid white;
    border-right: 2px solid white;
  }

`
);

const HeaderContainer = styled('div')`
  position: sticky;
  top: 0;
  width: 100%;
  max-width: 100%;
`;

const PoweredByLogoContainer = styled('div')`
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  margin: 0px;
  align-items: center;
  .powerdbyText {
    font-weight: 500;
    font-size: 12px;
    color: #a8a3a3;
  }
  .instacredLogo {
    margin-left: 10px;
    height: 14px;
    margin-top: -5px;
  }
`;

const CheckoutWidgetContainer = (props) => {
  const hideMobileContainer = ['cw-check-eligibility'];
  const showEditIcon = ['cw-select-lender', 'cw-select-emi-plan'];
  const { orderDetails, eligibilityDetails } = orderDetailsResponse;
  const { cartAmount, merchantName, merchantLogo } = orderDetails;
  const { mobile } = eligibilityDetails;

  const checkoutState = useCheckoutContext();
  const checkoutDispatch = useCheckoutDispatchContext();

  useEffect(() => {
    checkoutDispatch({
      type: 'STORE_STATE',
      payload: {
        merchantName: merchantName,
        merchantLogo: MerchantIcon,
        amount: cartAmount,
        eligibilityDetails: eligibilityDetails,
        mobileNo: eligibilityDetails.mobile,
      },
    });
  }, []);

  // TODO: consume from theme fetched from merchant or order-details
  const merchantTheme =
    {
      primaryColor: '#1A73E8',
    } || {};

  const checkoutTheme = {
    primaryColor: merchantTheme.primaryColor || '#1A73E8',
  };

  const isStringValidJSON = (stringJSON) => {
    let isValid = false;
    try {
      JSON.parse(stringJSON);
      isValid = true;
    } catch (e) {}
    return isValid;
  };

  useEffect(() => {
    const messageListener = (e) => {
      const parentMerchantOrigin = document.referrer;

      let merchantOrigin;
      if (parentMerchantOrigin) {
        try {
          const checkOrigin = new URL(parentMerchantOrigin);
          merchantOrigin = checkOrigin.origin;
        } catch (e) {}
      } else {
        try {
          const ancestorMerchantOrigin = window.location.ancestorOrigins[0];
          const checkOrigin = new URL(ancestorMerchantOrigin);
          merchantOrigin = checkOrigin.origin;
        } catch (e) {}
      }

      const isExpectedMerchantOrigin =
        merchantOrigin && merchantOrigin === e.origin;

      if (
        e.data &&
        typeof e.data === 'string' &&
        isStringValidJSON(e.data) &&
        isExpectedMerchantOrigin &&
        e.isTrusted
      ) {
        console.log(e);
      }
    };

    window.addEventListener('message', messageListener);

    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);

  const pageLoadInIframe = () => {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  return (
    pageLoadInIframe() && (
      <CheckoutWidgetUIContainer checkoutTheme={checkoutTheme || {}}>
        <div className='checkoutInnerContainer'>
          {checkoutState.closeIconConfig.showCancellationPopup && <CancelModal />}
          <HeaderContainer>
            <Header />
          </HeaderContainer>
          <div className='checkoutInnerWrapper'>
            <div className='cwChildrenContainer'>{props.children}</div>
          </div>
          <PoweredByLogoContainer>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '15px 0px',
                alignItems: 'center',
              }}>
              <div className='powerdbyText'>Powered by</div>
              <img
                src='https://iccdn.in/img/instacred-v1.0.svg'
                className='instacredLogo'
              />
            </div>
          </PoweredByLogoContainer>
        </div>
      </CheckoutWidgetUIContainer>
    )
  );
};

export default CheckoutWidgetContainer;



// WEBPACK FOOTER //
// ./components/partial/container/checkoutWidgetConatiner/index.js